export class PageMoveHistory {
	private size = 1;
	private stack: Array<{
		flagId?: string;
		undo(): void;
	}> = [];

	push({ undo }: { undo(): void }): void {
		this.stack.push({ undo });
		this.stack = this.stack.slice(-1 * this.size);
	}

	pop = ():
		| {
				flagId?: string;
				undo(): void;
		  }
		| undefined => this.stack.pop();

	peek = (): {
		flagId?: string;
		undo(): void;
	} => this.stack.slice(-1)[0];

	reset = (): void => {
		this.stack = [];
	};
}
